import Keycloak from "keycloak-js";
import Cookies from "js-cookie";

const keycloak = new Keycloak({
    url: process.env.REACT_APP_KC_SERVER_URL,
    realm: process.env.REACT_APP_KC_REALM_ID,
    clientId: process.env.REACT_APP_KC_CLIENT_ID,
    onLoad: 'login-required',
    checkLoginIframe: false
});


export const initKeycloak = async () => {
    /*
    * Init Keycloak and set user info in local storage
    */
    await keycloak.init({ onLoad: 'login-required', checkLoginIframe: false, flow: 'implicit' })
        .then(() => {
            // store username
            window.localStorage.setItem("automl-uid", keycloak.idTokenParsed?.preferred_username || "");
            // store email
            window.localStorage.setItem("automl-email", keycloak.idTokenParsed?.email || "");
            // set session cookie
            Cookies.set('KEYCLOAK_SESSION', keycloak.token, { sameSite: 'strict' });
        })
        .catch(error => {
            console.log('keycloak error', error);
        });
}

export const logoutKeycloakUser = async () => {
    Cookies.remove('KEYCLOAK_SESSION', {path: ''})
    window.localStorage.removeItem("automl-uid")
    keycloak.logout()
}

keycloak.onTokenExpired = () => {
    // at the moment we just logout the user if the token is expired
    // the implicit flow does not support token refresh
    // in keycloak the expiration time is set to 60 minutes
    logoutKeycloakUser()
}

export const getJWT = async () => {
    if (Cookies.get('KEYCLOAK_SESSION')) {
        return Cookies.get('KEYCLOAK_SESSION')
    }
    await keycloak.init({onLoad: 'login-required', checkLoginIframe: false}).then(() => {
        Cookies.set('KEYCLOAK_SESSION', keycloak.token, {sameSite: 'strict'})
    }).catch(error => {
        // eslint-disable-next-line no-console
        console.log('keycloak error', error);
    });
    return keycloak.token;

}